import {PASSWORD_REQUEST, PASSWORD_SUCCESS, PASSWORD_FAILURE,SHOW_MOBILE_VERIFIED,MOBILE_UPDATE_REQUEST,UPDATE_ACCOUNT_REQUEST,UPDATE_ACCOUNT_SUCCESS,UPDATE_ACCOUNT_FAILURE,TOST_MESSAGE } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
const initialState =  {openTostmsg:false,tostMsg:'',errorType:'',updatedmobileVerified:false};

export default function setting(state = initialState, action) {
    switch (action.type) {
        case PASSWORD_REQUEST:
            return{
                openTostmsg:false,
                tostMsg:'',
                errorType:'',
            };
        case PASSWORD_SUCCESS:
            return {
                ...state,
                openTostmsg:true,
                tostMsg:action.msg,
                errorType:"success",
              
            };
        case PASSWORD_FAILURE:
            return {
                ...state,
                openTostmsg:true,
                tostMsg:action.msg,
                errorType:"error",
            };
            case MOBILE_UPDATE_REQUEST:
            return {
                ...state,
                updatedmobileVerified:false,
                openTostmsg:false,
                tostMsg:'',
            };
            case SHOW_MOBILE_VERIFIED:
            return {
                ...state,
                updatedmobileVerified:true,
                openTostmsg:false,
                tostMsg:'',
                
            }; 
            case UPDATE_ACCOUNT_REQUEST:
            return{
                openTostmsg:false,
                tostMsg:'',
                errorType:"",
            };
        case UPDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                openTostmsg:true,
                tostMsg:action.msg,
                errorType:"",
              
            };
        case UPDATE_ACCOUNT_FAILURE:
            return {
                ...state,
                openTostmsg:true,
                tostMsg:action.msg,
                errorType:"error",
            };
            case TOST_MESSAGE:
                return {
                    ...state,
                    openTostmsg:action.openTost,
                    tostMsg:action.tostMsg,
                    errorType:action.errorType,
                };     
        default:
            return state
    }
}